import React from 'react';
import './Pokerwatch_new.css';
import Grid from '@material-ui/core/Grid';
import Suggestions from './Suggestions';
import DataTable from '../common/Table/index';
import UserIcon from '../../img/stableicon.png';
import MediaQuery from 'react-responsive';
import { Checkbox } from '@material-ui/core';
import CheckedIcon from 'material-ui/svg-icons/toggle/check-box';
import CheckBoxOutlineBlankIcon from "material-ui/svg-icons/toggle/check-box-outline-blank";

const UserCustomDiv = props => {
    const { enableUserProp, enableUserPropDiv,dialogContent} = props;
    return !dialogContent.isDialogOpen && <div>
        
     <nav className="navbar-fixed-top fixed-top-2" style={{
             height: '55px !important',
             minHeight: '5.5rem',
             marginLeft:'-2rem'
     }}>
        <div className="container mygame-header-container-div" style={{paddingTop:window.innerWidth>=768 ?'6px':'12.5px'}}>
        <div className="go-back-arrow-div" style={{marginTop:window.innerWidth>=768 ?'8px':'3px',marginLeft:'-7px'}}>
            <i className="fa fa-arrow-left " data-e2e="go-back-left-arrow" onClick={(e) => enableUserPropDiv(e,{},-1)} ></i></div>
            <span className='pokerwatch-team-header-row pokerwatch-team-header-row-team-name' style={{ fontSize: '16px' }}>{enableUserProp.row._id}</span>
            
        </div>
    </nav>
    {enableUserProp.component}
}</div>
}
const MobileView = (props) => {
    const { handleInputChange,searchHandler,enableUserPropDiv,enableUserProp, enableUserDirectory,toggleUserDirectory, teamNameData,displayResults, selectedTeams,userData, routeChange, NumberFormatter, teamData, openDialogBox, dialogContent, errorOBj, data, handleSort, handleCheck } = props;
    let iterateData = teamNameData && teamNameData.length > 0 && !enableUserDirectory? teamNameData : enableUserDirectory && displayResults ?displayResults : data;

    let selectedData = enableUserDirectory?userData ? userData:[]:selectedTeams;
    return enableUserProp && enableUserProp.status?<UserCustomDiv {...props}/> : <div >
        <div className='bootstrap-wrapper' style={{
            boxShadow: ' 0 2px 1px 0 rgba(0,0,0,0.15)', margin: '-15px -15px 0px -15px', padding: '15px 15px 0px 15px',
            position: 'sticky',
            top: '3.5rem',
            zIndex: '1',
            backgroundColor: 'white',
            height: '103px'
        }}>
            <Grid spacing={24} style={{ marginTop: '16px', paddingRight: '1rem' }}>
                <Grid item xs={12} style={{ marginTop: '-5px' }}>
                    <span className="pokerwatch-admin-stable-name">{enableUserDirectory?'User Directory':'Stable Directory'}</span><i className="fa fa-lg fa-chevron-down down-arrow" onClick={toggleUserDirectory}></i><UserDirectoryModal {...props} />
                </Grid>

                <Grid item xs={12} style={{marginTop:'10px'}}>
                    <Grid container spacing={24} >
                        <Grid item xs={11} style={{ paddingTop: '11px' }}>
                            <div className="mygame-header-search-div-mobile" >
                                <input className="mygame-header-search-text-mobile" data-e2e="team-search-button" type="text" placeholder={enableUserDirectory?"Search User":"Search Stable"} onChange={event => enableUserDirectory?searchHandler(event): handleInputChange(event, { "type": "team", "inputObj": { "name": event.target.value } })} />
                                <i className="fa fa-search fa-x search-icon" style={{ color: '#E8490D' }} data-e2e="team-search-icon" ></i>
                                {/* {!dialogContent.isDialogOpen && teamNameData && teamNameData.length > 0 ? <Suggestions data={teamNameData} actionPerform={routeChange} elemClass={'suggestions'} /> : ''} */}
                            </div>
                        </Grid>
                        
                        <Grid item xs={1} style={{ paddingTop: '11px' }}>
                            {selectedData && selectedData.length > 0 ? <button className= "mygame-header-button-create-plus" onClick= {e => openDialogBox(enableUserDirectory?'deleteUser':'deleteTeamModal')}
                             ><i className="fa fa-2x fa-trash"  ></i></button>
                                : <button className="mygame-header-button-create-plus" onClick={e => openDialogBox(enableUserDirectory?'createUser':'createTeamModal')}><i className="fa fa-lg fa-plus" data-e2e="stable-creation" ></i> </button>

                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>

        <div style={{ marginTop:enableUserDirectory?'20px': '7px', paddingRight: '1rem',paddingTop:'0px' }}>
            {iterateData && iterateData.length > 0 ? iterateData.map((item, index) => {
                return <Grid  key={index} container spacing={24} style={{ paddingLeft: '10px',marginTop:'0px',marginBottom:'0px', height: enableUserDirectory ?'64px':'55px',borderBottom: '1px solid #eee',paddingTop:enableUserDirectory ?'11px':'24px'}}>
                        <Grid item xs={9} style={{height:'34px', paddingTop:'0px'}} > 
                            
                            <div className='stable-name-div' onClick={(e) => enableUserDirectory ?enableUserPropDiv(e,item,index): routeChange(e, item)}>
                                {enableUserDirectory ? item._id:item.name}
                            </div>
                            {enableUserDirectory &&<div className='user-details'>
                                    {item.show_role} -- {item.loginDate} -- ISP:{item.accessIps}
                                </div>}
                            {/* <div className='stable-ownername-div'>
                                {item.ownerName}
                            </div> */}
                        </Grid>
                        <Grid item xs={3} style={{height:'34px', paddingTop:'0px'}} ><Checkbox
                            style={{ width: 15, height: 15, float: 'right' }}
                            checked={selectedData.includes(item) ? true : false}
                            onChange={(event) => { handleCheck(item) }}
                            icon={<CheckBoxOutlineBlankIcon style={{
                                height: '15px', width: '15px', border: '1px solid #858585',
                                borderRadius: '2px',
                                backgroundColor: '#FFFFFF',
                                boxShadow: '0 2px 4px 0 rgba(0,0,0,0.16)'
                            }} />}
                            checkedIcon={<CheckedIcon style={{ fill: "red" }} />}
                        /></Grid>

                    </Grid>
            }) : ''}
        </div>
    </div>

}

const UserDirectoryModal = props => {
    const { userDirectory, handleUserDirectory,enableUserDirectory } = props;

    return userDirectory ? <button className='user-directory-name' data-e2e="user-dictionary" onClick={handleUserDirectory} style={window.innerWidth<=1024?{
        marginLeft:enableUserDirectory ? '-14rem':'-15rem'  
    }:{}}><span>{enableUserDirectory ?'Stable Directory':'User Directory'}</span></button> : null

}

class PokerWatchAdmin extends React.Component {

    state = {
        dialogContent: this.props.dialogContent,
    };
    componentDidMount() {
        //console.log('this.props', this.props);

    }
    render() {
        
        let tableStyle = {
            thead: {
                height: '41.5px',
                background: '#FCFCFC',
                border: '1px solid #E8E8E8',
                borderLeft: '0px',
                borderRight: '0px'
            },
            tbody: {
                height: '72px',
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 1px 0px',

            },
            root: {
                width: '100%',
                marginTop: '23px',
                // overflowX: 'auto',
                paddingLeft: '0px !important',
                fontFamily: 'Roboto Medium',
                boxShadow: '0px 0px 0px 0px'
            },
            table:{
               
                marginTop: '23px',
                // overflowX: 'auto',
                paddingLeft: '0px !important',
                fontFamily: 'Roboto Medium',
                boxShadow: '0px 0px 0px 0px'
            },

            cell: {
                padding: '0px',
                fontSize: '16px',
                color: '#000000',
                fontFamily: "Roboto",
                fontWeight: '600'

            },
            headerCell:{
                paddingLeft:'15px',
                width:'0px',
                background: '#F6F6F6',
                border: '1px solid #E8E8E8',
                borderLeft: '0px',
                borderRight: '0px',
                position:'sticky',
                top:'13.1rem',
                zIndex:'1'
            }
        }
        const { handleInputChange,searchHandler, toggleUserDirectory,enableUserPropDiv,enableUserProp,enableUserDirectory, userDirectory, teamNameData, selectedTeams, routeChange, openDialogBox, dialogContent, errorOBj, data, displayResults,handleSort, handleCheckbox } = this.props;
        const stableHeaders =[
            { label: 'Stable Name', id: 'name', style: { width: '22rem', marginRight: '20px' }, colSpan: 1, sortEnabled: true, handleSort, sortOrder: 'asc', onClick: routeChange },
            { label: 'Owner', id: 'ownerName', colSpan: 2, sortEnabled: false, sortOrder: 'asc' },
        
        ]
        const useerDirectory = [
            { label: 'User Name', id: '_id',style: { width: '30rem'}, colSpan:1,  sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'Role', id: 'show_role', colSpan:1,  sortEnabled: false},
            { label: 'Most recent log in', colSpan:1, id: 'loginDate', sortEnabled: false},
            { label: 'Most recent log ip', colSpan:1, id: 'accessIps',  sortEnabled: false},
            {label:'',id:'more',colSpan:1,sortEnabled: false,onClick:enableUserPropDiv,componentDetails : enableUserProp}
        ]
        const headers = enableUserDirectory ?useerDirectory:stableHeaders;
        
        return <div>     
        <MediaQuery minWidth={1025}>
            {(matches) => {
                if (matches) {
                    return <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
                        <Grid container spacing={24} className="stable-header">
                            <Grid item xs style={{ marginTop: '9px' }}>
                                <span className="pokerwatch-admin-stable-name" >{enableUserDirectory?'User Directory':'Stable Directory'} </span><i className="fa fa-lg fa-chevron-down down-arrow" onClick={toggleUserDirectory} data-e2e="stable-dictionary-dropdown"></i><UserDirectoryModal {...this.props} />
                            </Grid>
                            <Grid item xs>
                                <Grid container spacing={24}>
                                    <Grid item xs={11}>
                                        <input className="mygame-header-search-text" data-e2e="team-search-button" type="text" placeholder={enableUserDirectory?"Search User":"Search Stable"} onChange={event => {enableUserDirectory?searchHandler(event): handleInputChange(event, { "type": "team", "inputObj": { "name": event.target.value } })}} />
                                        <button className="mygame-header-search-button"><i className="fa fa-lg fa-search search-icon" style={{ color: '#E8490D' }} data-e2e="team-search-icon" ></i></button>
                                        {!dialogContent.isDialogOpen && teamNameData && teamNameData.length > 0 && !enableUserDirectory ? <Suggestions data={teamNameData} actionPerform={routeChange} elemClass={'suggestions'} /> : ''}
                                    </Grid>
                                    <Grid item xs={1}>
                                        {selectedTeams && selectedTeams.length > 0 ? <button className="mygame-header-button-create-plus"  onClick={e => openDialogBox(enableUserDirectory?'deleteUser':'deleteTeamModal')} ><i className="fa fa-2x fa-trash" data-e2e="stable-delete" ></i></button>
                                            : <button className= "mygame-header-button-create-plus" onClick= {e => openDialogBox(enableUserDirectory?'createUser':'createTeamModal')} ><i className="fa fa-lg fa-plus" data-e2e="stable-creation" ></i> </button>

                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <DataTable showCheckBox={true} showCheckBoxAll={false} onCheck={handleCheckbox} headers={headers} rows={teamNameData && teamNameData.length > 0 && !enableUserDirectory ? teamNameData : 
                            enableUserDirectory && displayResults ?displayResults : 
                            data && data.length>0 ? data:[]} styles={tableStyle} selectedRows={selectedTeams}  />
                        {data && data.length == 0 ? <div className='user-icon-div' style={{ marginLeft: '41rem', marginTop: '-60rem' }}><img src={UserIcon} alt="stableCreation" style={{ height: '218px', width: '256px' }} onClick={e => openDialogBox('createTeamModal')} /><h1 style={{ marginLeft: '5rem' }}>Create Stable</h1></div> : ''}
                    </div>
                }
                else {
                    return <MobileView {...this.props} />
                }
            }}
        </MediaQuery>
        </div>

    }
}

export default PokerWatchAdmin;


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/pokerwatch_admin.js
 **/